import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { resolveAcademicPhase } from "../../../config/widgetConfig";

const tileVariants = {
    hidden: { opacity: 0, scale: 0.96 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

// Заголовок и подпись под числом для каждого периода учебного календаря
// (сам период определяет resolveAcademicPhase — см. config/widgetConfig.js).
const PHASE_TEXT = {
    before_session: {
        label: "routeList.session_label",
        note: "routeList.session_days_left",
    },
    session: {
        label: "routeList.session_now_label",
        note: "routeList.session_days_to_end",
    },
    holidays: {
        label: "routeList.holidays_label",
        note: "routeList.holidays_days_to_study",
    },
};

// Пересчитываем не чаще раза в час: число дней меняется только в полночь,
// а минутный таймер держал бы компонент в постоянном ререндере впустую.
const REFRESH_INTERVAL = 60 * 60 * 1000;

function CountdownSlide() {
    const { t } = useTranslation();
    const [state, setState] = useState(() => resolveAcademicPhase());

    useEffect(() => {
        const timer = setInterval(
            () => setState(resolveAcademicPhase()),
            REFRESH_INTERVAL,
        );
        return () => clearInterval(timer);
    }, []);

    const { phase, daysLeft } = state;
    const text = PHASE_TEXT[phase];
    // Счётчик показываем только когда есть что считать: у последних каникул
    // в календаре нет даты окончания, а phase "study" вообще без ориентира.
    const showCounter = Boolean(text) && daysLeft !== null && daysLeft > 0;

    // Текст без счётчика: последний день периода («сегодня заканчивается»)
    // и открытые каникулы попадают сюда же.
    const fallbackText =
        phase === "holidays"
            ? t("routeList.holidays_enjoy")
            : phase === "session"
              ? t("routeList.countdown_finished")
              : t("routeList.study_label");

    return (
        <motion.div
            className="w-full h-full rounded-[3vh] text-center bg-white shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] px-[2.6vw] flex flex-row items-center gap-[1.6vw]"
            variants={tileVariants}
            initial="hidden"
            animate="visible"
        >
            {showCounter ? (
                <>
                    <span className="text-[#246CE2] text-[4.4vh] font-extrabold tracking-tight leading-none flex-none">
                        {daysLeft}
                    </span>
                    <div className="flex flex-col gap-[0.3vh] min-w-0 text-left">
                        <span className="text-[1.3vh] font-bold tracking-[0.15vh] uppercase text-[#7B8290] truncate">
                            {t(text.label)}
                        </span>
                        <span className="text-[1.4vh] font-semibold text-[#7B8290] truncate">
                            {t(text.note)}
                        </span>
                    </div>
                </>
            ) : (
                <span className="w-full text-[1.8vh] font-bold text-[#246CE2] leading-snug">
                    {fallbackText}
                </span>
            )}
        </motion.div>
    );
}

export default CountdownSlide;
